import { IFormInfo } from '../form-fileds.model';

export const TA_SAF_FORM_INFO: IFormInfo = {
  name: {
    label: 'உங்கள் பெயர்',
    placeholder: 'உங்கள் பெயரை உள்ளிடவும்',
    readOnly: false,
    errMsg: {
      required: 'தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்',
      pattern: 'தயவுசெய்து செல்லுபடியாகும் பெயரை உள்ளிடவும்',
      minLength: 'பெயரில் குறைந்தது 3 எழுத்துகள் இருக்க வேண்டும்'
    }
  },
  email: {
    label: 'மின்னஞ்சல்',
    placeholder: 'மின்னஞ்சலை உள்ளிடவும்',
    readOnly: false,
    errMsg: {
      required: 'தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்',
      pattern: 'தயவுசெய்து செல்லுபடியாகும் மின்னஞ்சலை உள்ளிடவும்'
    }
  },
  raisingFor: {
    label: 'நீங்கள் யாருக்காக நிதி திரட்டுகிறீர்கள்?',
    placeholder: '',
    readOnly: false,
    options: [
      { value: 'self', label: 'நான்', icon: 'people' },
      { value: 'someoneElse', label: 'யாரோ மற்றவர்', icon: 'people' },
      { value: 'ngo', label: 'நிஜபயன்/தானம்', icon: 'people' }
    ],
    errMsg: { required: 'தயவுசெய்து ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்' }
  },
  ngo: {
    label: 'நிஜ அமைப்பின் பெயர்',
    placeholder: 'பெயரை உள்ளிடவும்',
    readOnly: false,
    errMsg: {
      required: 'தயவுசெய்து உங்கள் என்ஜிஓவை தேடி தேர்வுசெய்யவும்',
      ngoNotFound: 'என்ஜிஓ பதிவு செய்யப்படவில்லை',
      custom: 'வேறு என்ஜிஓ ஒன்றைத் தேர்ந்தெடுக்கவும்'
    }
  },
  relation: {
    label: 'இந்த நிதி என் …',
    placeholder: 'அல்லது வேறு தேர்வு செய்யவும்',
    readOnly: false,
    priorOptions: [
      { value: 'Mother', label: 'தாய்' },
      { value: 'Father', label: 'தந்தை' },
      { value: 'Son', label: 'மகன்' },
      { value: 'Daughter', label: 'மகள்' },
      { value: 'Friend', label: 'நண்பர்' },
    ],
    options: [
      { value: 'Aunt', label: 'மாதா/அத்தை' },
      { value: 'Brother', label: 'அண்ணன்/தம்பி' },
      { value: 'Cousin', label: 'மாமியார்/கூட்டப்பிள்ளை' },
      { value: `Friend's Family`, label: `நண்பரின் குடும்பம்` },
      { value: 'Granddaughter', label: 'மகள்/மருமகள்' },
      { value: 'Grandfather', label: 'தாத்தா/பாட்டி' },
      { value: 'Grandmother', label: 'பாட்டி/பாட்டி' },
      { value: 'Grandson', label: 'மாருதி/மருமகள்' },
      { value: 'Husband', label: 'கணவர்' },
      { value: 'Legal ward', label: 'சட்டபூர்வ பாதுகாக்கப்பட்டவர்' },
      { value: 'Nephew', label: 'மூத்த மகன் / இளைய மகன்' },
      { value: 'Niece', label: 'மூத்த மகள் / இளைய மகள்' },
      { value: 'Relative', label: 'உறவினர்' },
      { value: 'Sister', label: 'சகோதரி' },
      { value: 'Twins', label: 'இரட்டை குழந்தைகள்' },
      { value: 'Uncle', label: 'மாமா/சித்தப்பா' },
      { value: 'Wife', label: 'மனைவி' },
      { value: 'Pet', label: 'செல்லப்பிராணி' },
      { value: 'Other', label: 'மற்றவை' },
    ],
    errMsg: { required: 'தயவுசெய்து ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்' }
  },
  beneficiaryName: {
    label: 'பயனாளியின் பெயர்',
    placeholder: 'பயனாளியின் பெயரை உள்ளிடவும்',
    readOnly: false,
    errMsg: {
      required: 'தயவுசெய்து பயனாளியின் பெயரை உள்ளிடவும்',
      pattern: 'தயவுசெய்து செல்லுபடியாகும் பெயரை உள்ளிடவும்',
      minLength: 'பெயரில் குறைந்தது 3 எழுத்துகள் இருக்க வேண்டும்'
    }
  },
  age: {
    label: 'வயது குழு?',
    options: [
      { value: '0-5', label: '0‑5 ஆண்டுகள்', icon: 'person' },
      { value: '5-18', label: '5‑18 ஆண்டுகள்', icon: 'person' },
      { value: '18-60', label: '18‑60 ஆண்டுகள்', icon: 'person' },
      { value: '60+', label: '60+ ஆண்டுகள்', icon: 'person' },
    ],
    errMsg: { required: 'தயவுசெய்து ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்' }
  },
  fundRequired: {
    label: 'நீங்கள் எவ்வளவு நிதி திரட்ட விரும்புகிறீர்கள்?',
    prefix: '₹',
    placeholder: '000000',
    readOnly: false,
    note: 'உங்களுக்கு ஒரு கணக்கு எண்ணை தற்போது பூர்த்தி செய்து பின்னர் மாற்றலாம். குறைந்தபட்சம் ₹2000 என்ற்டையை நிரப்பவும்',
    errMsg: {
      required: 'தயவுசெய்து தொகையை உள்ளிடவும்',
      min: 'தேவையான குறைந்தபட்சம் ₹2000 ஐ உள்ளிடவும்',
      max: 'தயவுசெய்து ₹5,00,00,000 க்கும் குறைவாக அல்லது சமமான தொகையை உள்ளிடவும்'
    }
  },
  cause: {
    label: 'இந்த பட்டியலில் உங்கள் நிதி திரட்டும் நோக்கம் எது?',
    readOnly: false,
    showMore: 'மேலும் காரணங்களை காண்க',
    showLess: 'குறைந்த காரணங்களை காண்க',
    errMsg: { required: 'தயவுசெய்து ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்' }
  },
  ailment: {
    label: 'இயக்கு / மருத்துவ நிலை',
    placeholder: 'தேடவும் மற்றும் தேர்ந்தெடுக்கவும்',
    readOnly: false,
    errMsg: { required: 'தயவுசெய்து உள்ளிடவும் மற்றும் தேர்ந்தெடுக்கவும்' }
  },
  hospitalisation: {
    label: 'உங்கள் மருத்துவமனை சேர்க்கை நிலை எது?',
    readOnly: false,
    options: [
      { value: 'Recently discharged from the hospital', label: 'சமீபத்தில் வெளியேற்றப்பட்டது', icon: 'people' },
      { value: 'Currently hospitalised', label: 'தற்போது மருத்துவமனையில் உள்ளார்', icon: 'people' },
      { value: 'Will be hospitalised soon', label: 'விரைவில் சேர்க்கப்படுவர்', icon: 'people' },
    ],
    lowPriorOptions: [
      { value: 'Does not require hospitalisation', label: 'மருத்துவமனை சேர்க்கை தேவையில்லை', icon: 'block' },
    ],
    errMsg: { required: 'தயவுசெய்து ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்' }
  },
  hospital: {
    label: 'மருத்துவமனை பெயர்',
    placeholder: 'மருத்துவமனையைத் தேர்வு செய்க',
    readOnly: false,
    errMsg: {
      required: 'மருத்துவமனையைத் தேர்வு செய்யவும்'
    }
  },
  sameCityAsHospital: {
    label: 'நான் மருத்துவமனை உள்ள நகரத்தில் இருக்கிறேன்',
    readOnly: false
  },
  city: {
    label: 'நகரம்',
    placeholder: 'நகரத்தை உள்ளிடவும்',
    readOnly: false,
    errMsg: {
      required: 'நகரத்தை உள்ளிடவும்',
      custom: 'தயவுசெய்து ஒரு செல்லுபடியாகும் நகரத்தைத் தேர்ந்தெடுக்கவும்'
    }
  },
  title: {
    label: 'நிதி திரட்டும் தலைப்பு',
    placeholder: 'தலைப்பு உள்ளிடவும்',
    readOnly: false,
    errMsg: {
      required: 'தயவுசெய்து தலைப்பை உள்ளிடவும்',
      minLength: 'குறைந்தபட்சம் 5 எழுத்துகள் தேவை',
      maxLength: 'அதிகபட்சம் 75 எழுத்துகள் அனுமதிக்கப்படுகின்றன'
    }
  },
  about: {
    label: 'உங்கள் கதையை நாங்கள் எழுதினோம் — எப்போது வேண்டுமானாலும் திருத்தலாம்',
    label1: 'இந்த நிதி திரட்டல் உங்களுக்கு ஏன் முக்கியம் என்பதை விளக்குங்கள்',
    label2: 'உங்கள் கதையை கூறுங்கள்',
    placeholder: 'உங்கள் நோக்கத்தை நியாயப்படுத்தும் மற்றும் ஆதரவாளரை காணொளி செய்ய வைக்கும் கதையை எழுதுங்கள்',
    readOnly: false,
    errMsg: {
      required: 'இந்த புலம் தேவை',
      minLength: 'குறைந்தபட்சம் 50 எழுத்துகள் தேவை'
    }
  },
  aboutMerge: {
    label: 'நிதி எதற்காக பயன்படுத்தப்படும்?',
    placeholder: 'கல்விக்கட்டணம், பயணம், புத்தகங்கள் போன்றவை',
    readOnly: false,
    errMsg: {
      required: 'தயவுசெய்து பயன்பாட்டு விவரங்களை உள்ளிடவும்'
    }
  },
  media: {
    label: `உங்கள் நோக்கத்தை ஆதரிக்க புகைப்படத்தை பதிவேற்றவும் <span class="optional">(விருப்பத்தேர்வு)</span>`,
    readOnly: false
  },

  insuranceOptIn: {
    label: `என் குடும்ப உறுப்பினர்களில் ஒருவருக்கு <strong>₹1.2 லட்சம் காப்பீட்டுத் திட்டத்திற்கு</strong> நிதி திரட்டுங்கள்.`,
    readOnly: false,
  },
  agree: {
    label: `நான் கெட்டோவின் <a href="{{terms}}" target="_blank">பயன்பாட்டு விதிமுறைகள்</a>, <a href="{{privacy}}" target="_blank">தனியுரிமைக் கொள்கை</a> மற்றும் <a href="{{plans}}" target="_blank">திட்டங்கள் மற்றும் விலை</a> என்பவற்றை ஏற்கிறேன். மேற்காணும் தகவல்கள் என் அறிவும் நம்பிக்கையும் அடிப்படையாக கொண்டு வழங்கப்பட்டவை என நான் உறுதி செய்கிறேன். மேலே வழங்கப்பட்ட தகவல்கள் தவறாகவோ தவிர்த்ததோ என்றால் அதன் பொறுப்பு எனக்கு உண்டு. இது கட்டாயமாகின், சட்டப் பிரமாணங்களுடன் பகிரப்படும் என்பதை நான் ஒப்புக்கொள்கிறேன்.`,
    readOnly: false,
    errMsg: { required: 'தயவுசெய்து ஒப்புதலைப் படித்து தேர்ந்தெடுக்கவும்' }
  }
};

export const TA_OTHER_INFO = {
  verifyEmail: {
    title: 'ஒருமுறை உறுதிப்படுத்தப்பட்டால், மின்னஞ்சலை மாற்ற முடியாது',
    confirm: 'உறுதிப்படுத்து',
    edit: 'தொகு'
  },
  verifyEmailOTP: {
    title: `மின்னஞ்சலுக்கு அனுப்பப்பட்ட OTP ஐ உள்ளிடவும்`,
    confirm: 'சரிபார்க்கவும்',
    edit: 'மின்னஞ்சலைத் திருத்து'
  }
};
